<template>
    <section>
        <div class="header-line grid-container">
            <div class="profile-label grid-item" data-qa="payments-heading">
                Payments
            </div>
        </div>
        <template lang="html">
            <div class="table-scroller">
                <ds-table-grid
                    :data="payments"
                    align="center"
                    :sort-field="sortField"
                    :sort-ascending="sortAscending"
                    @sort="sortTable"
                >
                    <ds-table-grid-column
                        label="Id"
                        width="160"
                    >
                        <template slot-scope="payment">
                            <span>
                                {{ payment.paymentId }}
                            </span>
                        </template>
                    </ds-table-grid-column>

                    <ds-table-grid-column
                        label="Amount"
                        width="160"
                    >
                        <template slot-scope="payment">
                            <span>
                                {{ payment.formattedPaymentAmount }}
                            </span>
                        </template>
                    </ds-table-grid-column>

                    <ds-table-grid-column
                        label="Unassigned"
                        width="160"
                    >
                        <template slot-scope="payment">
                            <span>
                                {{ payment.formattedUnassignedAmount }}
                            </span>
                        </template>
                    </ds-table-grid-column>

                    <ds-table-grid-column
                        label="Payment date"
                        align="right"
                        sortable
                    >
                        <template slot-scope="payment">
                            <span>
                                {{ dateFormatDate(payment.paymentDate, 'MMM D, YYYY') }}
                            </span>
                        </template>
                    </ds-table-grid-column>
                </ds-table-grid>
            </div>
        </template>
    </section>
</template>

<script>
import moment from 'moment';

export default {
    props: {
        payments: Array,
    },

    data() {
        return {
            sortAscending: false,
            sortField: 'lastUpdated',
        };
    },

    methods: {
        dateFormatDate(date, format = 'll') {
            const formattedDate = moment(date).isValid() ? date : new Date(date);

            return moment(formattedDate).format(format);
        },

        sortTable({ ascending }) {
            const factor = ascending === true ? -1 : 1;

            this.sortAscending = ascending;
            this.payments = this.payments.sort((prev, next) => {
                if (prev.paymentDate > next.paymentDate) return -1 * factor;
                if (prev.paymentDate < next.paymentDate) return 1 * factor;

                return 0;
            });
        },
    },
};
</script>

<style lang="scss" scoped>
.header-line{
    display: flex;
}

.grid-container{
    display: flex;
    margin: $spacing-250 0;
}

.grid-item{
    margin: auto;
}

.profile-label {
    margin-left: 0;
    font-size: 1.75rem;
    color: $color-text;
}

.table-scroller{
    white-space: nowrap;
}

@media only screen and ($medium) {
    .grid-container {
        margin-top: 1.875rem;
        display: block;
    }
}
</style>
